import React, { useMemo, useState } from 'react'
import {
  FormLabel,
  FormControl,
  Textarea,
  Input,
  Box,
  Stack,
  Wrap,
  WrapItem,
  FormHelperText,
  FormErrorMessage,
} from "@chakra-ui/react"
import noop from 'lodash/noop';

import DateInput from '../../components/FormField/DateInput';

const acceptFiles = [
  'image/*',
  '.doc',
  '.docx',
  '.pdf',
].join()

const Details = ({ watch = noop, register = noop, errors }) => {
  const date = watch('date')

  return (
    <Stack px="2" spacing="3">
      <FormControl>
        <FormLabel>期望檔期</FormLabel>
        <Wrap>
          <WrapItem width="12em">
            <DateInput max={date?.end} label="起始日期" {...register('date.start')} />
          </WrapItem>
          <WrapItem width="12em">
            <DateInput min={date?.start} label="結束日期" {...register('date.end')} />
          </WrapItem>
        </Wrap>
      </FormControl>
      <FormControl isRequired>
        <FormLabel>簡述合作需求</FormLabel>
        <Textarea rows={4} {...register('description', { required: true })} />
        <FormHelperText>如有相關雲端連結，也可直接附上</FormHelperText>
      </FormControl>

      <FormControl isInvalid={errors?.file}>
        <FormLabel>相關檔案</FormLabel>
        <Input
          type="file"
          accept={acceptFiles}
          {...register('file', {
            validate: {
              size: file => file?.[0]?.size > 5 * 1048576 ? '檔案大小超過限制' : true,
            }
          })}
        />
        <FormHelperText>可上傳圖片檔、文件檔，大小不超過5MB</FormHelperText>
        <FormErrorMessage>{errors?.file?.message}</FormErrorMessage>
      </FormControl>
    </Stack>
  )
}

export default Details
